import {useState} from 'react'

const usePaginationCounts = (initialPage = 1, itemsPerPage = 10) => {
  const [pagination, setPagination] = useState({
    page: initialPage,
    size: itemsPerPage,
    totalElement: 0,
    number: 1,
    firstPage: 1,
    lastPage: 0,
    totalPages: 0,
  })

  const updatePagination = (paginations: {
    page: number
    size: number
    number: number
    firstPage: number
    lastPage: number
    totalPages: number
    totalElement: number
  }) => {
    setPagination((prevState) => ({
      ...prevState,
      page: paginations.page,
      size: paginations.size,
      number: paginations.number,
      totalElement: paginations.totalElement,
      firstPage: paginations.firstPage,
      lastPage: paginations.lastPage,
      totalPages: paginations.totalPages,
    }))
  }

  const handlePageChange = (pageNumber: number) => {
    setPagination((prevState) => ({
      ...prevState,
      page: pageNumber,
    }))
  }

  const handlePagePerItem = (itemsPerPage: number) => {
    setPagination((prevState) => ({
      ...prevState,
      size: itemsPerPage,
      page: 1,
    }))
  }

  const backToDefault = () => {
    setPagination((prevState) => ({
      ...prevState,
      page: initialPage,
      size: itemsPerPage,
      number: 1,
      firstPage: 1,
      lastPage: 0,
      totalPages: 0,
    }))
  }

  return {
    pagination,
    setPagination,
    updatePagination,
    handlePageChange,
    handlePagePerItem,
    backToDefault,
  }
}

export default usePaginationCounts
